//@vendor
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
//@commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const OKSliderInput = require('commonsComponents/OKSliderInput');
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKModal = require('components/commons/OKModal/OKModal');
//@constants
const TRANSLATION_KEY_PREFIX = 'accountQuotaSelector-';
const { MULTIPLE_QUOTA, NO_PACK_KEY, PACK_KEY } = require('constants/lavanda');
const { DEFERRAL_PAYMENT_OPTION_ACTION_EVENT, DEFERRAL_PAYMENT_QUOTA_INPUT_ACTION_EVENT, DEFERRAL_PAYMENT_QUOTA_SLIDER_ACTION_EVENT } = require('constants/tagging');
//helpers
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { getDeferralOptionTag, getNumberOfQuotas } = require('utilities/lavandaHelper');
const { recordLink } = require('utilities/tagging');
//core
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
//@compontents
const { AccountPaymentPurchaseDeferralTable } = require('./accountPaymentPurchaseDeferralTable');
const DeferralSelector = require('components/deferralSelector/deferralSelector');

class QuotaSelector extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false
        };

        this.handleToggleModal = this.handleToggleModal.bind(this);
        this.handleQuotaQuantityChange = this.handleQuotaQuantityChange.bind(this);
        this.handleDeferralSelectorChange = this.handleDeferralSelectorChange.bind(this);
        this.handleInputOnFocus = this.handleInputOnFocus.bind(this);
    }


    buildValuesAndButtonSection(interests, quotaValue, quotaQuantity) {
        const {
            fetching,
            financedPurchasedAmount,
            isLavandaCard,
            lavandaEnabled,
            loading,
            totalAmountOwed,
        } = this.props;
        const language = getLanguage();
        const isLavandaFlow = lavandaEnabled && isLavandaCard;
        let content = <LoadingSection />;

        if (!loading && !fetching) {
            const plainAmountQuotaObject = getPlainAmountObject(quotaValue);
            const plainAmountInterestObject = getPlainAmountObject(interests);
            const plainAmountFinancedPurchaseObject = getPlainAmountObject(financedPurchasedAmount);
            const plainAmountTotalAmountOwedObject = getPlainAmountObject(totalAmountOwed);

            content = (
                <section>
                    <section className="quota-selector-slider-section__values-section">
                        <div className="quota-selector-slider-section__value">
                            <FormattedText value={TRANSLATION_KEY_PREFIX + 'quotaValue'} />
                            <div className="quota-selector-slider-section__value-amount">
                                <OneLineSymbolAmount
                                    amountObject={plainAmountQuotaObject}
                                    language={language}
                                    amountObjectFormatted={formatAmountObject(plainAmountQuotaObject, true)} />
                            </div>
                        </div>
                        {  isLavandaFlow &&
                            <React.Fragment>
                                <div className="quota-selector-slider-section__value">
                                    <FormattedText value="lavanda-lavanda_totalQuotas" />
                                    <div className="quota-selector-slider-section__value-amount">
                                        {quotaQuantity}
                                    </div>
                                </div>
                                <div className="quota-selector-slider-section__value">
                                    <FormattedText value="lavanda-lavanda_totalAmountOwed" />
                                    <div className="quota-selector-slider-section__value-amount">
                                        <OneLineSymbolAmount
                                            positiveAmount
                                            amountObject={plainAmountTotalAmountOwedObject}
                                            language={language}
                                            amountObjectFormatted={formatAmountObject(plainAmountTotalAmountOwedObject, true)}
                                        />
                                    </div>
                                </div>
                                <div className="quota-selector-slider-section__value">
                                    <FormattedText value="lavanda-lavanda_creditAmount" />
                                    <div className="quota-selector-slider-section__value-amount">
                                        <OneLineSymbolAmount
                                            positiveAmount
                                            amountObject={plainAmountFinancedPurchaseObject}
                                            language={language}
                                            amountObjectFormatted={formatAmountObject(plainAmountFinancedPurchaseObject, true)}
                                        />
                                    </div>
                                </div>
                            </React.Fragment>
                        }
                        <div className={
                            classNames('quota-selector-slider-section__value quota-selector-slider-section__value--interests', {
                                'pull-right': !isLavandaFlow 
                            })}
                        >
                            <FormattedText value={TRANSLATION_KEY_PREFIX + 'interests'} />
                            <div className="quota-selector-slider-section__value-amount">
                                <OneLineSymbolAmount
                                    amountObject={plainAmountInterestObject}
                                    language={language}
                                    amountObjectFormatted={formatAmountObject(plainAmountInterestObject, true)} />
                            </div>
                        </div>
                    </section>
                    <section className="quota-selector-slider-section__button-section">
                        <OKButton modifier="link-complementary" onClick={this.handleToggleModal}>
                            <FormattedText value={TRANSLATION_KEY_PREFIX + 'amortizationChart'} />
                        </OKButton>
                    </section>
                    {isLavandaFlow && 
                        <div className="quota-selector-slider-section__legal">
                            <FormattedText value="lavanda-lavanda_typeOfAmortization" />
                        </div>
                    }
                </section>
            );
        }

        return content;
    }

    handleQuotaQuantityChange(quantity, sliderChanged) {
        const { isLavandaCard, lavandaEnabled } = this.props;
        const isLavandaFlow = lavandaEnabled && isLavandaCard;

        isLavandaFlow && sliderChanged && recordLink(window.utag_last_name, DEFERRAL_PAYMENT_QUOTA_SLIDER_ACTION_EVENT, `${quantity} cuotas`);
        this.props.setQuotaQuantity(quantity);
    }

    handleInputOnFocus(){
        const { isLavandaCard, lavandaEnabled } = this.props;
        const isLavandaFlow = lavandaEnabled && isLavandaCard;

        isLavandaFlow && recordLink(window.utag_last_name, DEFERRAL_PAYMENT_QUOTA_INPUT_ACTION_EVENT, 'cuotas');
    }

    handleDeferralSelectorChange(quantity){
        const choosenOption = getNumberOfQuotas(quantity);

        recordLink(window.utag_last_name, DEFERRAL_PAYMENT_OPTION_ACTION_EVENT, getDeferralOptionTag(quantity));
        this.props.setQuotaQuantity(choosenOption);
        this.props.setDeferralOption(quantity);
    }

    handleToggleModal() {
        this.setState({
            showModal: !this.state.showModal
        });
    }

    render() {
        const {
            chosenDeferral,
            currentQuota,
            fetching,
            installmentList,
            interests,
            isLavandaCard,
            lavandaEnabled,
            loading,
            maxQuotas,
            minQuotas,
            quotaMonthly,
            threeMonthQuotaAmount,
            tin,
            tae,
            immCard,
        } = this.props;
        const isLavandaFlow = lavandaEnabled && isLavandaCard;
        const isPack = immCard.get('isDiamond') || immCard.get('isPremium');
        const legalNotesKey = isPack ? PACK_KEY : NO_PACK_KEY;
        const legalNotes = isLavandaFlow && (
            <div className="quota-selector-slider-section__legal">
                <FormattedText value={legalNotesKey} injectedStrings={[tin, tae]}/>
            </div>
        );

        let slider;
        let content = <LoadingSection />;

        if (!loading){
            const sliderLabel = formatText(TRANSLATION_KEY_PREFIX + 'title');
            const valuesSection = this.buildValuesAndButtonSection(interests, quotaMonthly, currentQuota);
            const unit = formatText('cardPaymentPurchaseDeferralSliderSection-cardPaymentPurchaseDeferralSliderSection_fee');
            const maxLabel = `${formatText('cardPaymentPurchaseDeferralSliderSection-cardPaymentPurchaseDeferralSliderSection_max')} ${maxQuotas}`;
            const showSlider = !lavandaEnabled || !isLavandaCard || chosenDeferral === MULTIPLE_QUOTA;

            if (showSlider){
                slider =  (
                    <section className="quota-selector-slider-section__slider">
                        <OKSliderInput
                            defaultValue={currentQuota}
                            max={maxQuotas}
                            maxLabel={maxLabel}
                            min={minQuotas}
                            onChange={this.handleQuotaQuantityChange}
                            onFocus={this.handleInputOnFocus}
                            title={sliderLabel}
                            unit={unit}
                        />
                    </section>
                );
            }

            content = (
                <section className="quota-selector-slider-section">
                    <OKModal
                        content={<AccountPaymentPurchaseDeferralTable immInstallments={installmentList} />}
                        isOpen={this.state.showModal}
                        onCloseCallback={this.handleToggleModal}
                        size="large"
                        title="cardPaymentPurchaseDeferralTable-title"
                    />
                    { isLavandaFlow &&
                        <DeferralSelector 
                            onClick={this.handleDeferralSelectorChange}
                            selected={this.props.chosenDeferral}
                            threeMonthQuotaAmount={threeMonthQuotaAmount}
                            tin={tin}
                            tae={tae}
                        />
                    }
                    {slider}
                    {valuesSection}
                    {legalNotes}
                </section>
            );
        } else if (isLavandaFlow){
            content = (
                <React.Fragment>
                    <DeferralSelector 
                        onClick={this.handleDeferralSelectorChange}
                        selected={0}
                        threeMonthQuotaAmount={threeMonthQuotaAmount}
                        tin={tin}
                        tae={tae}
                    />
                    {fetching && <LoadingSection /> }
                    {legalNotes}
                </React.Fragment>
            );
        }

        return content;
    }
}

QuotaSelector.propTypes = {
    chosenDeferral: PropTypes.string,
    immCard: PropTypes.object,
    fetching: PropTypes.bool,
    financedPurchasedAmount:  PropTypes.shape({
        amount: PropTypes.number,
        currency: PropTypes.string,
    }),
    isLavandaCard: PropTypes.bool,
    lavandaEnabled: PropTypes.bool,
    loading: PropTypes.bool,
    minQuotas: PropTypes.number,
    maxQuotas: PropTypes.number,
    currentQuota: PropTypes.number,
    interests: PropTypes.shape({
        amount: PropTypes.number,
        currency: PropTypes.string
    }),
    quotaMonthly: PropTypes.shape({
        amount: PropTypes.number,
        currency: PropTypes.string
    }),
    installmentList: PropTypes.object,
    setDeferralOption: PropTypes.func,
    setQuotaQuantity: PropTypes.func,
    threeMonthQuotaAmount: PropTypes.object,
    totalAmountOwed:  PropTypes.shape({
        amount: PropTypes.number,
        currency: PropTypes.string,
    }),
    tin: PropTypes.string,
    tae: PropTypes.string,
};

module.exports.constructor = QuotaSelector;
module.exports.QuotaSelector = QuotaSelector;
